import React from 'react';
import './styles.css';
import { Link } from 'react-router-dom';
import { Row, Col } from 'antd';
import { BupSpinner, DividerContainer, ItemList } from '@BUP/components';
import ConoceInstrumentos from '@BUP/assets/Images/Data/data_(1)_conoce-instrumentos.png';
import RespondeDiagnostico from '@BUP/assets/Images/Data/data_(3)_responde-diagnostico.png';
import Sociograma from '@BUP/assets/Images/Data/data_sociograma.png';
import ImageData from '@BUP/assets/Images/Data/data-18.png';
import { STUDENT } from '@BUP/constants';
import {
  useAuth,
  useGetSurveysSociogram,
  useGetParticipantsTerminated,
} from '@BUP/hooks';
import { useTranslation } from 'react-i18next';

const DataStudentPage = () => {
  const { user } = useAuth();
  const [t] = useTranslation();
  const roleType = user?.roles?.type;
  const enrollmentId = user?.enrollmentId;
  const { isLoadingSurveySociogram, surveySociogram } = useGetSurveysSociogram(
    user
  );

  const participants =
    typeof surveySociogram?.participants === 'number'
      ? [surveySociogram?.participants]
      : surveySociogram?.participants;
  const isParticipant =
    participants?.some((elem) => elem === enrollmentId) || false;

  const {
    isLoadingParticipantsTerminated,
    participantsTerminated,
  } = useGetParticipantsTerminated(enrollmentId);

  const isParticipantTerminated = participantsTerminated
    ? participantsTerminated?.some(
        (elem) => parseInt(elem.enrollmentId, 10) === enrollmentId
      )
    : false;

  return (
    <>
      <DividerContainer title="BRAVE UP! DATA" />
      {isLoadingSurveySociogram || isLoadingParticipantsTerminated ? (
        <BupSpinner size="large" />
      ) : (
        <>
          <p className="welcome-paragraph">
            {t('pages.data.welcomeTextStudent')}
          </p>
          <ItemList
            className="item-list"
            count="1"
            src={ConoceInstrumentos}
            title={
              <Link to="data/instruments">{t('pages.data.title1Student')}</Link>
            }
            description={t('pages.data.description1Student')}
            url={
              <Link className="itemList-link" to="data/instruments">
                {t('pages.data.linkTextHere')}
              </Link>
            }
            urlLink="data/instruments"
          />
          <ItemList
            count="2"
            src={RespondeDiagnostico}
            title={
              <Link className="itemList-link" to="data/confirm-survey">
                {t('pages.data.title3ECE')}
              </Link>
            }
            description={t('pages.data.description2Student')}
            url={
              <Link className="itemList-link" to="data/confirm-survey">
                {t('pages.data.linkTextHere')}
              </Link>
            }
          />
          {roleType === STUDENT &&
          surveySociogram?.isActive === true &&
          isParticipant ? (
            <ItemList
              count="3"
              src={Sociograma}
              title={
                <Link className="itemList-link" to="data/sociogram">
                  {t('pages.data.title3Student')}
                </Link>
              }
              description={t('pages.data.description3Student')}
              url={
                <Link className="itemList-link" to="data/sociogram">
                  {t('pages.data.linkTextHere')}
                </Link>
              }
              isParticipantTerminated={isParticipantTerminated}
              message={t('pages.data.answerSociogram.answeredSociogram')}
            />
          ) : null}

          <Row justify="end">
            <Col className="gutter-row" span={12}>
              <img
                style={{ width: '100%' }}
                src={ImageData}
                alt="Imagen Data"
              />
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default DataStudentPage;
